export const APP_CREDENTIALS = {
  videoStreaming: { username: "superadmin@example.com", password: "superadmin123" },
  urbanFarming: { username: "superadmin@example.com", password: "superadmin123" },
  expenseTracker: { username: "naxax67257@omanarts.com", password: "naxax67257@omanartscom" },
  quizorra: { username: "superadmin@example.com", password: "superadmin123" },
  threeDView: { username: "superadmin", password: "superadmin123" },
  ulcerSight: { username: "demo-ulcer@conversantech.com", password: "demo-password" },
  aiSalesTraining: { username: "demo-sales@conversantech.com", password: "demo-password" },
  walkthroughTraining: { username: "demo-walkthrough@conversantech.com", password: "demo-password" },
  projectManagement: { username: "admin", password: "password123" },
  realEstatePlatform: { username: "9999999999", password: "ct@00" }
};
